import React, { Component } from 'react';
import { connect } from 'react-redux';
import packageJson from '../../../package.json';
import api from '../../axios-local-api';
import Spinner from '../../components/UI/Spinner/Spinner';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import classes from './Modem.css';

export class Modem extends Component {
  render() {
    if (this.props.loading) {
      return <Spinner />;
    } else {
      return (
        <Box>
          <div className={classes.Spacer} />

          <div className={classes.Equipment} style={{ color: '#777' }}>
            <div>
              <b>Modem</b>
              <div id ="ModemDetails">{this.props?.data?.typeDescription || this.props?.data?.model || "N/A"}</div>
            </div>
            <span className={classes.PackageVersion}>
              v{packageJson.version}
            </span>
          </div>
        </Box>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Modem, api));
